// Programmatic SEO sur les categories.
//
// CATEGORIES_SEO (racines + sous-categories + slugs FR + h1 + intro) DERIVE
// desormais du dictionnaire canonique unique (taxonomy/gively-taxonomy.json ->
// taxonomy.generated.js) — LOT C.2b. On n'edite plus la taxonomie ici : on
// edite le canonique puis `npm run generate-taxonomy`. Restent DEFINIS ici (non
// derives car specifiques SEO front) : les ALIAS longue traine et les VILLES.
// Le miroir backend backend/constants/categories_seo.py reste synchronise et
// GARDE par le test de coherence (CATEGORY_ID_TO_SLUG == canonique) en attendant
// sa propre convergence.

import TAXONOMY from "./taxonomy.generated";

// CATEGORIES_SEO DERIVE du dictionnaire canonique unique
// (taxonomy/gively-taxonomy.json -> taxonomy.generated.js). NE PLUS EDITER a la
// main : editer le canonique puis `npm run generate-taxonomy`. Ordre SEO =
// TAXONOMY.seoOrder ; les sous-categories sans slug (catch-all volontairement
// hors SEO, ex. services/other) sont exclues. Coherence garantie par
// check-taxonomy.js (CI + pre-commit).
export const CATEGORIES_SEO = TAXONOMY.seoOrder.map((id) => {
  const c = TAXONOMY.categories[id];
  return {
    id: c.id,
    slug: c.slug,
    name: c.seoName,
    h1: c.h1,
    intro: c.intro,
    subs: c.subcategories
      .filter((s) => s.slug)
      .map((s) => ({ id: s.id, slug: s.slug, name: s.seoName })),
  };
});

// Aliases longue traine — slugs synonymes qui mappent vers une cat ou subcat
// existante. Permet de capter des recherches Google avec des intentions
// commerciales fortes ("pas cher", "occasion") sans dupliquer le contenu :
// chaque alias rend la meme page que sa cible (canonical pointe sur target).
export const CATEGORIES_ALIASES = [
  { slug: "vetements-occasion-pas-cher", targetCat: "fashion" },
  { slug: "electronique-occasion-pas-cher", targetCat: "electronics" },
  { slug: "meubles-occasion-pas-cher", targetCat: "home", targetSub: "furniture" },
  { slug: "livres-occasion-pas-cher", targetCat: "culture", targetSub: "books" },
  { slug: "jouets-occasion", targetCat: "kids", targetSub: "toys" },
  { slug: "velo-occasion", targetCat: "vehicles", targetSub: "bikes" },
  { slug: "smartphone-occasion", targetCat: "electronics", targetSub: "phones" },
  { slug: "console-occasion", targetCat: "electronics", targetSub: "gaming" },
];

// ── Villes pour le SEO programmatique catégorie × ville ──────────────
// Les 40 plus grandes villes FR. Le `name` est celui stocké dans
// listing.city (filtre backend insensible à la casse, match partiel) et
// affiché dans le H1. Le `slug` est l'URL SEO-friendly. Combiné aux 11
// catégories racines : 11 × 40 = 440 pages longue traîne
// ("vêtements d'occasion à Toulouse", "électronique d'occasion à Lyon"…).
export const CITIES_SEO = [
  { slug: "paris", name: "Paris" },
  { slug: "marseille", name: "Marseille" },
  { slug: "lyon", name: "Lyon" },
  { slug: "toulouse", name: "Toulouse" },
  { slug: "nice", name: "Nice" },
  { slug: "nantes", name: "Nantes" },
  { slug: "montpellier", name: "Montpellier" },
  { slug: "strasbourg", name: "Strasbourg" },
  { slug: "bordeaux", name: "Bordeaux" },
  { slug: "lille", name: "Lille" },
  { slug: "rennes", name: "Rennes" },
  { slug: "reims", name: "Reims" },
  { slug: "saint-etienne", name: "Saint-Étienne" },
  { slug: "le-havre", name: "Le Havre" },
  { slug: "toulon", name: "Toulon" },
  { slug: "grenoble", name: "Grenoble" },
  { slug: "dijon", name: "Dijon" },
  { slug: "angers", name: "Angers" },
  { slug: "nimes", name: "Nîmes" },
  { slug: "villeurbanne", name: "Villeurbanne" },
  { slug: "clermont-ferrand", name: "Clermont-Ferrand" },
  { slug: "le-mans", name: "Le Mans" },
  { slug: "aix-en-provence", name: "Aix-en-Provence" },
  { slug: "brest", name: "Brest" },
  { slug: "tours", name: "Tours" },
  { slug: "amiens", name: "Amiens" },
  { slug: "limoges", name: "Limoges" },
  { slug: "annecy", name: "Annecy" },
  { slug: "perpignan", name: "Perpignan" },
  { slug: "besancon", name: "Besançon" },
  { slug: "metz", name: "Metz" },
  { slug: "orleans", name: "Orléans" },
  { slug: "rouen", name: "Rouen" },
  { slug: "mulhouse", name: "Mulhouse" },
  { slug: "caen", name: "Caen" },
  { slug: "nancy", name: "Nancy" },
  { slug: "avignon", name: "Avignon" },
  { slug: "poitiers", name: "Poitiers" },
  { slug: "versailles", name: "Versailles" },
  { slug: "pau", name: "Pau" },
  { slug: "nanterre", name: "Nanterre" },
  { slug: "courbevoie", name: "Courbevoie" },
  { slug: "creteil", name: "Créteil" },
  { slug: "boulogne-billancourt", name: "Boulogne-Billancourt" },
  { slug: "argenteuil", name: "Argenteuil" },
  { slug: "montreuil", name: "Montreuil" },
  { slug: "saint-denis", name: "Saint-Denis" },
  { slug: "roubaix", name: "Roubaix" },
  { slug: "tourcoing", name: "Tourcoing" },
  { slug: "dunkerque", name: "Dunkerque" },
  { slug: "asnieres-sur-seine", name: "Asnières-sur-Seine" },
  { slug: "colombes", name: "Colombes" },
  { slug: "aulnay-sous-bois", name: "Aulnay-sous-Bois" },
  { slug: "rueil-malmaison", name: "Rueil-Malmaison" },
  { slug: "champigny-sur-marne", name: "Champigny-sur-Marne" },
  { slug: "vitry-sur-seine", name: "Vitry-sur-Seine" },
  { slug: "beziers", name: "Béziers" },
  { slug: "la-rochelle", name: "La Rochelle" },
  { slug: "cannes", name: "Cannes" },
  { slug: "antibes", name: "Antibes" },
  { slug: "calais", name: "Calais" },
  { slug: "saint-nazaire", name: "Saint-Nazaire" },
  { slug: "merignac", name: "Mérignac" },
  { slug: "ajaccio", name: "Ajaccio" },
  { slug: "bourges", name: "Bourges" },
  { slug: "colmar", name: "Colmar" },
  { slug: "quimper", name: "Quimper" },
  { slug: "drancy", name: "Drancy" },
  { slug: "issy-les-moulineaux", name: "Issy-les-Moulineaux" },
  { slug: "levallois-perret", name: "Levallois-Perret" },
  { slug: "noisy-le-grand", name: "Noisy-le-Grand" },
  { slug: "neuilly-sur-seine", name: "Neuilly-sur-Seine" },
  { slug: "cergy", name: "Cergy" },
  { slug: "venissieux", name: "Vénissieux" },
  { slug: "pessac", name: "Pessac" },
  { slug: "valence", name: "Valence" },
  { slug: "antony", name: "Antony" },
  { slug: "troyes", name: "Troyes" },
  { slug: "montauban", name: "Montauban" },
  { slug: "niort", name: "Niort" },
  { slug: "lorient", name: "Lorient" },
  { slug: "chambery", name: "Chambéry" },
  { slug: "saint-quentin", name: "Saint-Quentin" },
  { slug: "beauvais", name: "Beauvais" },
  { slug: "cholet", name: "Cholet" },
  { slug: "bayonne", name: "Bayonne" },
  { slug: "vannes", name: "Vannes" },
  { slug: "frejus", name: "Fréjus" },
  { slug: "narbonne", name: "Narbonne" },
  { slug: "sarcelles", name: "Sarcelles" },
  { slug: "evry-courcouronnes", name: "Évry-Courcouronnes" },
  { slug: "albi", name: "Albi" },
  { slug: "belfort", name: "Belfort" },
  { slug: "evreux", name: "Évreux" },
  { slug: "la-seyne-sur-mer", name: "La Seyne-sur-Mer" },
  { slug: "saint-malo", name: "Saint-Malo" },
  { slug: "chateauroux", name: "Châteauroux" },
  { slug: "chalon-sur-saone", name: "Chalon-sur-Saône" },
  { slug: "brive-la-gaillarde", name: "Brive-la-Gaillarde" },
  { slug: "carcassonne", name: "Carcassonne" },
  { slug: "tarbes", name: "Tarbes" },
  { slug: "blois", name: "Blois" },
  { slug: "angouleme", name: "Angoulême" },
  { slug: "castres", name: "Castres" },
  { slug: "laval", name: "Laval" },
  { slug: "cherbourg-en-cotentin", name: "Cherbourg-en-Cotentin" },
  { slug: "arles", name: "Arles" },
  { slug: "gap", name: "Gap" },
  { slug: "aubervilliers", name: "Aubervilliers" },
  { slug: "bobigny", name: "Bobigny" },
  { slug: "meaux", name: "Meaux" },
];

export const resolveCitySlug = (citySlug) =>
  CITIES_SEO.find((c) => c.slug === citySlug) || null;

// Helper — resolve un slug d'URL vers une entree {cat, sub?}.
// Cherche d'abord dans les categories racines, puis dans les sous-categories
// (matching parent + child), puis dans les aliases.
export const resolveCategorySlug = (parentSlug, childSlug = null) => {
  // Cas 1 : /categorie/:parent/:child
  if (childSlug) {
    const cat = CATEGORIES_SEO.find(c => c.slug === parentSlug);
    if (!cat) return null;
    const sub = cat.subs.find(s => s.slug === childSlug);
    if (!sub) return null;
    return { cat, sub, isAlias: false };
  }
  // Cas 2 : /categorie/:slug — racine
  const cat = CATEGORIES_SEO.find(c => c.slug === parentSlug);
  if (cat) return { cat, sub: null, isAlias: false };
  // Cas 3 : /categorie/:slug — alias longue traine
  const alias = CATEGORIES_ALIASES.find(a => a.slug === parentSlug);
  if (alias) {
    const targetCat = CATEGORIES_SEO.find(c => c.id === alias.targetCat);
    if (!targetCat) return null;
    const targetSub = alias.targetSub
      ? targetCat.subs.find(s => s.id === alias.targetSub)
      : null;
    return { cat: targetCat, sub: targetSub, isAlias: true, aliasSlug: parentSlug };
  }
  return null;
};
